import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ModalBox from '../../components/ModalBox';
import NewPlan from '../../components/NewPlan';
import './quickAccess.scss';
import SolicitarIcon from '../../image/solicitar-consulta.svg';
import FaturarIcon from '../../image/faturarGTO.svg';
import ElegibilidadeIcon from '../../image/elegibilidade.svg';
import PerfilIcon from '../../image/perfil.svg';

class QuickAccess extends Component {
  constructor(props) {
    super(props);
    this.state = { modalActive: false };
    this.toggleCreate = this.toggleCreate.bind(this);
  }

  toggleCreate() {
    this.setState(state => ({
      modalActive: !state.modalActive
    }));
  }

  render() {
    return (
      <div data-testid="quick-access" className="QuickAccess">
        <h3 className="menu-title">O que você deseja fazer?</h3>
        <Link
          to={{
            pathname: '/listagem-pacientes',
            state: {
              add: true,
              title: 'Solicitar e Consultar GTO'
            }
          }}
        >
          <button type="submit" className="btn-menu solicitar">
            <img src={SolicitarIcon} alt="Solicitar e Consultar GTO" />
            Solicitar e Consultar GTO
          </button>
        </Link>
        <Link
          to={{
            pathname: '/listagem-pacientes',
            state: {
              add: false,
              title: 'Faturar GTO'
            }
          }}
        >
          <button type="submit" className="btn-menu faturar">
            <img src={FaturarIcon} alt="Faturar GTO" />
            Faturar GTO
          </button>
        </Link>
        <Link to="/elegibilidade">
          <button type="submit" className="btn-menu elegibilidade">
            <img src={ElegibilidadeIcon} alt="Consultar Elegibilidade e Cobertura" />
            Consultar Elegibilidade e Cobertura
          </button>
        </Link>
        <Link to="/perfil">
          <button type="submit" className="btn-menu perfil">
            <img src={PerfilIcon} alt="Perfil" />
            Meu perfil
          </button>
        </Link>
        <ModalBox
          modalActive={this.state.modalActive}
          modalLabel="Novo plano de tratamento"
          onChange={this.toggleCreate}
        >
          <NewPlan />
        </ModalBox>
      </div>
    );
  }
}

export default QuickAccess;
